import { logUserAction } from '@office-start/telemetry-service';
/**
 * logUserAction telemetry
 * @param actionResult The result produced in the action. See values in ActionResult
 * @param actionTarget The target of an user action. See values in ActionTarget
 * @param eventName The name of event location
 * @param id A unique, constrained identifier for the purposes of distinguish different action events
 * @param type Describes the action resulting in the firing of the event. Default set to Click. See values in ActionType
 * @param subArea Granular UX Area that makes up part of the UX Area. Default value is 'Other'
 * @param targetId Using this to record appId in certain cases. From eng hub docs: For Referral string needed to transform, use this field to store original referral id.
 */
export const logAppHostUserAction = (actionResult, actionTarget, eventName, id, type, subArea, targetId) => {
    logUserAction({
        type,
        eventName,
        id,
        subArea,
        result: actionResult,
        target: actionTarget,
        targetId,
        area: 'MOSAppHost',
    });
};
//# sourceMappingURL=logAppHostUserAction.js.map